var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.23,28.13c.02-6.34-3.33-7.55-6.19-7.76-4.72-.35-8.2,2.54-8.2,2.54l2.59,2.65c2.76-2.21,7.42-1.75,7.79,1.13,0,0-4.08,.92-4.98,1.08-2.84,.6-4.7,.85-6.19,2.95-1.29,2.03-.95,5.14,.95,6.82,2.63,2.33,8.07,2.33,10.8-.82,0,0,.34,1.77,.58,2.32h4.11c-1.73-3.97-1.27-8.23-1.26-10.91Zm-4.01,2.85c-.23,1.86-1.48,4.11-4.89,4.55-2.1,.27-4.1-1.1-3.05-3.03,.33-.6,1.08-1.07,2.06-1.21,.6-.09,1.27-.16,1.97-.28,1.54-.25,3.03-.54,3.91-.88,0,0,.03,.63,0,.85Z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.69,29.88c.06-5.45-2.95-9.32-8.39-9.3-5.33-.06-8.57,4.06-8.49,9.31,0,2.81,.8,5.07,2.39,6.77,2,2.3,5.81,3.01,8.87,2.24,2.21-.53,3.94-2.03,5.2-3.94l-3.47-1.91c-2.58,4.3-8.52,2.81-8.75-2.22h12.62l.02-.96Zm-12.37-2.37c.96-4.24,7.29-4.44,8.18,0H5.31Z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.61,8.68C34.49,4.67,23.03,5.18,1.84,17.02c-1.16,.65-1.17,.29-.89-.05C2.42,15.22,21.34-.32,38.13,1.15c4.9,.43,13.62,3.27,15.07,12.73,1.45,9.44-2.84,15-4.13,15.3,1.71-6.58,.6-15.96-7.46-20.5Z",
    fill: "#019eda"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.02,22.35v16.69h4.08V22.35h-4.08Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.06,
    cy: 17.17,
    r: 2.63,
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiaLogo);
export default __webpack_public_path__ + "static/media/eia-logo.613b76400359e56c6349c68e2fb4881a.svg";
export { ForwardRef as ReactComponent };